// Localization file, segregated based on game name.
// *** NOTE ***
// Those general info are used across different games
// should always maintained in general object to prevent
// double info. Please refer en.js as full example.

const ja = {
  general: {
    wallet: "ベットクレジット",
    menulogout: "HOME",// "ログアウト",
    goodroad: "ドラゴンアラート",
    menufavourite: "Favourite",
    favouritegame: "Favourite Game",
    availablegame: "Available Game",
    confirm: "Confirm",
    menusfx: "SFX",
    menuon: "オン",
    menuoff: "オフ",
    menurules: "規則",
    menuresult: "結果",
    menustatement: "明細",
    menunotification: "お知らせ",
    menuviewhistory: "履歴を表示",
    menufullscreen: "全画面",
    marketclosed: "マーケット終了",
    menutrend: "傾向",
    menusimple: "シンプル",
    menunormal: "普通",

    draw_no: "ドロー番号",
    rebet: "再ベット",
    no_more_bet: "これ以上の賭けはありません",
    sum: "合計",
    next_draw: "次のドロー",
    last_bets_for: "最後の賭け",
    bet_total: "賭けた合計",
    no_bets_last_round: "前のラウンドに賭けはありません。",
    max: "最大",
    payout: "支払い",
    min_to: "最小",
    max_to: "最大",
    cancel: "キャンセル",
    bet: "賭けを行う",
    ref: "参照番号",
    gap: "ギャップ",

    sum_bs_short: "合計大/小",
    sum_oe_short: "合計奇/偶",
    Big: "大",
    Small: "小",
    Even: "偶数",
    Odd: "奇数",
    Dice: "ダイス",
    Triple: "トリプル",
    // High: "高",
    // Low: "低",
    Black: "黑",
    Red: "赤",
    Joker: "ジョーカー",

    //for history TabPane
    Result: "結果",
    Sum_Player: "プレイヤー合計",
    Sum_Banker: "バンカー合計",
    CARD_HISTORY: "カード履歴",
    STATISTICS: "統計",
    RED_BLACK: "赤/黒",
    HI_LO: "アップ/ダウン",
    Player: "プレイヤー",
    Tie: "引き分け",
    Banker: "バンカー",
    PLACE_TICKET: "賭け",
    PLACE_FAIL: " 賭けに失敗しました！",
    PLACE_SUCCESS: " 賭けに成功しました！",
    ERROR_MIN_TO:
      "申し訳ございません、最低ベットより低い金額は賭けられません。",
    ERROR_MAX_TO:
      "申し訳ございません、最大ベットより高い金額は賭けられません。",
    ERROR_MAX_DR: "申し訳ございません、各ドローのマックスベットを超えました。",
    ERROR_MAX_BTDR:
      "申し訳ございません、各ドローのベットタイプがマックスベットを超えました。",
    ERROR_NMB: "申し訳ございません、これ以上賭けられません。",
    ERROR_GAME_UA:
      "現在、賭ける事が出来ません。詳細について当社にお問い合わせください。",
    ERROR_REBET_DONE:
      "申し訳ございません、すでに先ほどのベットを賭けなおしました。",
    ERROR_TO: "申し訳ございません、もう一度金額を入力してください。",
    ERROR_XAMOUNT: "申し訳ございません、賭けを行う資金が足りません。",
    ERROR_206: "勝ちの制限に達しました！アップラインに連絡してください。",
    ERROR_207: "負けの制限に達しました！アップラインに連絡してください。",
    ERROR_208:
      " アカウントが一時停止しました！アップラインに連絡してください。",
    ERROR_209:
      " アカウントが無効になりました。アップラインに連絡してください。",
  },

  tai_xiu: {
    dicehistory: "ダイス履歴",
    o1group: "大/トリプル/小",
    o2group: "大/トリプル/小",
    o3group: "大/トリプル/小",
    o4group: "奇数/偶数",
    o5group: "奇数/偶数",

    o11group: "特定ナンバー",
    o21group: "特定ナンバー",
    o31group: "特定ナンバー",
    o41group: "特定ナンバー",
    o51group: "特定ナンバー",
    o61group: "特定ナンバー",
    o104group: "特定合計値",
    o105group: "特定合計値",
    o106group: "特定合計値",
    o107group: "特定合計値",
    o108group: "特定合計値",
    o109group: "特定合計値",
    o110group: "特定合計値",
    o111group: "特定合計値",
    o112group: "特定合計値",
    o113group: "特定合計値",
    o114group: "特定合計値",
    o115group: "特定合計値",
    o116group: "特定合計値",
    o117group: "特定合計値",

    o1: "大",
    o1_trend: "大",
    o2: "小",
    o2_trend: "小",
    o3: "いずれかのトリプル",
    o3_trend: "AT",
    o4: "奇数",
    o4_trend: "奇",
    o5: "偶数",
    o5_trend: "偶",

    o11: "ダイス 1",
    o12: "2x ダイス 1",
    o13: "3x ダイス 1",
    o21: "ダイス 2",
    o22: "2x ダイス 2",
    o23: "3x ダイス 2",
    o31: "ダイス 3",
    o32: "2x ダイス 3",
    o33: "3x ダイス 3",
    o41: "ダイス 4",
    o42: "2x ダイス 4",
    o43: "3x ダイス 4",
    o51: "ダイス 5",
    o52: "2x ダイス 5",
    o53: "3x ダイス 5",
    o61: "ダイス 6",
    o62: "2x ダイス 6",
    o63: "3x ダイス 6",

    o104: "4",
    o104_trend: "4",
    o105: "5",
    o105_trend: "5",
    o106: "6",
    o106_trend: "6",
    o107: "7",
    o107_trend: "7",
    o108: "8",
    o108_trend: "8",
    o109: "9",
    o109_trend: "9",
    o110: "10",
    o110_trend: "10",
    o111: "11",
    o111_trend: "11",
    o112: "12",
    o112_trend: "12",
    o113: "13",
    o113_trend: "13",
    o114: "14",
    o114_trend: "14",
    o115: "15",
    o115_trend: "15",
    o116: "16",
    o116_trend: "16",
    o117: "17",
    o117_trend: "17",

    "1_dice": "ワンダイス",
    "2_dice": "ツーダイス",
    "3_dice": "スリーダイス",
  },

  hi_lo: {
    o1: "アップ",
    o1_trend: "アップ",
    o2: "ダウン",
    o2_trend: "ダウン",
    o3: "赤",
    o3_trend: "赤",
    o4: "黑",
    o4_trend: "黑",
    o5: "レンジ2-9",
    o5_trend: "2-9",
    o6: "レンジJQKA",
    o6_trend: "JQKA",
    o7: "レンジKA",
    o7_trend: "KA",
    o101: "レンジA",
    o101_trend: "A",
    o102: "レンジ2",
    o102_trend: "2",
    o103: "レンジ3",
    o103_trend: "3",
    o104: "レンジ4",
    o104_trend: "4",
    o105: "レンジ5",
    o105_trend: "5",
    o106: "レンジ6",
    o106_trend: "6",
    o107: "レンジ7",
    o107_trend: "7",
    o108: "レンジ8",
    o108_trend: "8",
    o109: "レンジ9",
    o109_trend: "9",
    o110: "レンジJ",
    o110_trend: "J",
    o111: "レンジQ",
    o111_trend: "Q",
    o112: "レンジK",
    o112_trend: "K",
    o113: "ジョーカー",
    o113_trend: "JK",

    //for new-bet-lot
    o1group: "アップ/ダウン",
    o2group: "アップ/ダウン",
    o3group: "赤/黑",
    o4group: "赤/黑",
    o5group: "特定レンジ",
    o6group: "特定レンジ",
    o7group: "特定レンジ",
    o101group: "特定レンジ",
    o102group: "特定レンジ",
    o103group: "特定レンジ",
    o104group: "特定レンジ",
    o105group: "特定レンジ",
    o106group: "特定レンジ",
    o107group: "特定レンジ",
    o108group: "特定レンジ",
    o109group: "特定レンジ",
    o110group: "特定レンジ",
    o111group: "特定レンジ",
    o112group: "特定レンジ",
    o113group: "特定レンジ",
  },

  domino: {
    main: "メイン",
    result: "メイン",
    o1: "プレイヤー",
    o1_trend: "P",
    o2: "引き分け",
    o2_trend: "/",
    o3: "バンカー",
    o3_trend: "B",
    //player
    o4: "大",
    o4_trend: "大",
    o5: "小",
    o5_trend: "小",
    o6: "奇数",
    o6_trend: "奇",
    o7: "偶数",
    o7_trend: "偶",
    //banker
    o8: "大",
    o8_trend: "大",
    o9: "小",
    o9_trend: "小",
    o10: "奇数",
    o10_trend: "奇",
    o11: "偶数",
    o11_trend: "偶",
    o12_trend: "/",

    //for new-bet-lot
    o1group: "プレイヤー/引き分け/バンカー",
    o2group: "プレイヤー/引き分け/バンカー",
    o3group: "プレイヤー/引き分け/バンカー",
    o4group: "プレイヤー大/小",
    o5group: "プレイヤー大/小",
    o6group: "プレイヤー奇数/偶数",
    o7group: "プレイヤー奇数/偶数",
    o8group: "バンカー大/小",
    o9group: "バンカー大/小",
    o10group: "バンカー奇数/偶数",
    o11group: "バンカー奇数/偶数",

    P_BS: "P 大/小",
    P_OE: "P 奇/偶",
    B_BS: "B 大/小",
    B_OE: "B 奇/偶",

    PLAYER: "プレイヤー",
    BANKER: "バンカー",
    PLAYER_WIN: "プレイヤー勝ち",
    BANKER_WIN: "バンカー勝ち",
    TIE: "引き分け",

    PLAYER_BIG: "プレイヤー大",
    PLAYER_SMALL: "プレイヤー小",
    PLAYER_ODD: "プレイヤー奇数",
    PLAYER_EVEN: "プレイヤー偶数",

    BANKER_BIG: "バンカー大",
    BANKER_SMALL: "バンカー小",
    BANKER_ODD: "バンカー奇数",
    BANKER_EVEN: "バンカー偶数",
  },

  fantan: {
    o1group: "Fan",
    o2group: "Ssh",
    o3group: "Kwok",
    o4group: "Nim",
    o5group: "Nga",
    o6group: "奇数/偶数",
    o7group: "引き分け",
    total: "合計",
    odd: "奇数",
    even: "偶数",
    fan: "Fan",
    ssh: "Ssh",
    kwok: "Kwok",
    nga: "Nga",
    nim: "Nim",
    fan1: "Fan1",
    fan2: "Fan2",
    fan3: "Fan3",
    fan4: "Fan4",
    odd_trend: "奇",
    even_trend: "偶",
    result: "結果",
    history: "履歴",
    OE: "奇/偶",
  },

  maxracing: {
    o1: "C(ja)",
    o1_trend: "C(ja)",
    o2: "Big(ja)",
    o2_trend: "B(ja)",
    o3: "Small(ja)",
    o3_trend: "S(ja)",
    o4: "Odd(ja)",
    o4_trend: "O(ja)",
    o5: "Even(ja)",
    o5_trend: "E(ja)",
    o6: "Big(ja)",
    o6_trend: "B(ja)",
    o7: "Small(ja)",
    o7_trend: "S(ja)",
    o8: "Odd(ja)",
    o8_trend: "O(ja)",
    o9: "Even(ja)",
    o9_trend: "E(ja)",
    o10: "G1(ja)",
    o10_trend: "G1(ja)",
    o11: "G2(ja)",
    o11_trend: "G2(ja)",
    o12: "G3(ja)",
    o12_trend: "G3(ja)",
    o13: "G4(ja)",
    o13_trend: "G5(ja)",
    o14: "G5(ja)",
    o14_trend: "G5(ja)",

    //for new-bet-lot
    o1group: "Player/Tie/Banker",
    o2group: "Player/Tie/Banker",
    o3group: "Player/Tie/Banker",
    o4group: "Player Big/Small",
    o5group: "Player Big/Small",
    o6group: "Player Odd/Even",
    o7group: "Player Odd/Even",
    o8group: "Banker Big/Small",
    o9group: "Banker Big/Small",
    o10group: "Banker Odd/Even",
    o11group: "Banker Odd/Even",

    Champion: "Champion(ja)",
    C_BS: "C B/S(ja)",
    C_OE: "C O/E(ja)",
    S_BS: "S B/S(ja)",
    S_OE: "S O/E(ja)",
    Group: "Group(ja)",
    Place_champ: "Place Champion(ja)",
    Place_sum_champ: "Place Sum Champion(ja)",
    Runner_up: "Runner-up(ja)",
    Race_result: "Race Result(ja)",
  },
};

export default ja;
